import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../../shared/components/Input';
import { InputCNPJCPF } from '../../../../../shared/components/InputCNPJ';
import Divider from '@mui/material/Divider';
import { InputTelephone } from '../../../../../shared/components/InputTelephone';
import { InputCEP } from '../../../../../shared/components/InputCEP';
import { TabPanel } from '@mui/lab';
import { Alert, Button } from '@mui/material';
import { Save, Update, HowToReg } from '@mui/icons-material';

interface TabEmitenteProps {
  values: any;
  forncedor: any;
  /**
   * [27/10/2026] Preenchido quando o CNPJ do emitente JA existe na tabela CLIENTE, mas
   * sem a marca de fornecedor. Enquanto houver um, "Criar" nao aparece: criar daria 500
   * (CNPJ duplicado) e deixava o usuario sem saida nenhuma.
   */
  emitenteEmOutroPapel: any;
  marcarEmitenteComoFornecedor: () => void;
  updateEmitente: () => void;
  createEmitente: () => void;
}

export const TabEmitente = ({ values, forncedor, emitenteEmOutroPapel, marcarEmitenteComoFornecedor, updateEmitente, createEmitente } : TabEmitenteProps) => {
  return (
    <TabPanel value='2'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Typography className='col-span-8' variant='h6'>
          Dados Emitente
        </Typography>
        <Input
          disabled={true}
          label='Razão Social'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.xNome}
        />
        <Box className={'col-span-4'} />
        <InputCNPJCPF
          disabled={true}
          label='CNPJ'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.CNPJ}
        />
        <InputCNPJCPF
          disabled={true}
          label='CPF'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.CPF}
        />
        <Input
          disabled={true}
          label='Inscrição Estadual'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.IE}
        />
        <Input
          disabled={true}
          label='Inscrição Estadual ST'
          className='col-span-2'
          name='usu_nome'
          value={''}
        />
        <Input
          disabled={true}
          label='Regime Tributário:'
          className='col-span-4'
          name='usu_nome'
          value={''}
        />
        <Input
          disabled={true}
          label='Inscrição Municipal'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.IM}
        />
        <Input
          disabled={true}
          label='CNAE'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.CNAE}
        />
        <Divider className='col-span-8' />
        <Typography className='col-span-8' variant='h6'>
          Dados Contato
        </Typography>
        <InputTelephone
          disabled={true}
          label='Telefone'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.fone}
        />
        <InputCEP
          disabled={true}
          label='CEP'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.CEP}
        />
        <Input
          disabled={true}
          label='Logradouro'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xLgr}
        />
        <Input
          disabled={true}
          label='Número'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.nro}
        />
        <Input
          disabled={true}
          label='Complemento'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.cmp}
        />
        <Input
          disabled={true}
          label='Bairro'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xBairro}
        />
        <Input
          disabled={true}
          label='Código Municipio'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.cMun}
        />
        <Input
          disabled={true}
          label='Municipio'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xMun}
        />
        <Input
          disabled={true}
          label='Unidade Federativa'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.UF}
        />
        <Input
          disabled={true}
          label='Código Pais'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.cPais}
        />
        <Input
          disabled={true}
          label='Pais'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xPais}
        />
      </Box>
      <Box className='grid grid-cols-8 gap-7 pt-6'>
        <Divider className='col-span-8' />
        {!forncedor?.cli_id && emitenteEmOutroPapel?.cli_id && (
          <Alert
            severity={emitenteEmOutroPapel?.jaEhFornecedor ? 'warning' : 'info'}
            className='col-span-8'
            action={
              emitenteEmOutroPapel?.jaEhFornecedor ? undefined : (
                <Button
                  startIcon={<HowToReg />}
                  variant='contained'
                  color='primary'
                  onClick={() => marcarEmitenteComoFornecedor()}
                >
                  Marcar como fornecedor
                </Button>
              )
            }
          >
            Este CNPJ já está cadastrado como {emitenteEmOutroPapel?.papeis}:{' '}
            <strong>
              {emitenteEmOutroPapel?.cli_nome ?? emitenteEmOutroPapel?.cli_razao}
            </strong>{' '}
            (código {emitenteEmOutroPapel?.cli_id}).{' '}
            {emitenteEmOutroPapel?.jaEhFornecedor
              ? 'Ele já é fornecedor, mas a busca por fornecedor não o encontra — confira o CPF/CNPJ gravado no cadastro dele.'
              : 'Marcar também como fornecedor?'}
            {emitenteEmOutroPapel?.outrosCadastros?.length > 0 && (
              <>
                <br />
                <strong>Atenção:</strong> este CNPJ tem mais de um cadastro
                (códigos {emitenteEmOutroPapel.outrosCadastros.join(', ')}{' '}
                também). A marcação vale para o{' '}
                {emitenteEmOutroPapel?.cli_id}.
              </>
            )}
          </Alert>
        )}
        <Input
          disabled={true}
          label='Código Fornecedor'
          className='col-span-1'
          name='for_id'
          value={forncedor?.cli_id ?? ''}
        />
        <Input
          disabled={true}
          label=''
          className='col-span-4'
          name='usu_nome'
          value={forncedor?.cli_razao ?? ''}
        />
        <Box className='col-span-1' />
        <Box className='col-span-2 pt-2'>
          {/* [27/10/2026] "Criar" so quando o CNPJ realmente nao existe. Havendo
              cadastro em outro papel, o caminho e a marcacao acima - o INSERT seria
              recusado por CNPJ duplicado. */}
          {!forncedor?.cli_id && !emitenteEmOutroPapel?.cli_id && (
            <Button
              fullWidth
              startIcon={<Save />}
              variant='contained'
              color='primary'
              size='large'
              className='col-span-6'
              onClick={() => createEmitente()}
            >
              Criar
            </Button>
          )}
          {forncedor?.cli_id && (
            <Button
              fullWidth
              startIcon={<Update />}
              variant='contained'
              color='primary'
              size='large'
              className='col-span-6'
              onClick={() => updateEmitente()}
            >
              Atualizar
            </Button>
          )}
        </Box>
      </Box>
    </TabPanel>
  )
}